import * as Scrivito from "scrivito";

const NavigationElementWidget = Scrivito.provideWidgetClass(
  "NavigationElementWidget",
  {
    attributes: {
      link: "reference",
      headline: "string",
      iconCss: "string",
      icon: "string",
      items: "referencelist",
      subItems: "referencelist",
    },
    onlyInside: "InpageNavigationWidget",
    extractTextAttributes: ["headline"],
  }
);

export default NavigationElementWidget;
